import useRoutes from '../../hooks/useRoutes';

export const getFormReferencePathFromFormMatchPath = (
  matchPath: string,
  routes: ReturnType<typeof useRoutes>,
  datasetId: string,
  formId: string,
  referenceDatasetId: string,
  field: string,
  sourceItemId?: string,
  itemId?: string,
  subsetId?: string,
  subsetItemId?: string
) => {
  if (matchPath === routes.relative.formAddAction()) {
    return routes.formAddActionReference(formId, referenceDatasetId, field);
  }
  if (matchPath === routes.relative.formListAddAction()) {
    return routes.formListAddActionReference(
      datasetId,
      formId,
      referenceDatasetId,
      field
    );
  }
  if (matchPath === routes.relative.formListCopyAction() && sourceItemId) {
    return routes.formListCopyActionReference(
      datasetId,
      formId,
      sourceItemId,
      referenceDatasetId,
      field
    );
  }
  if (matchPath === routes.relative.formListEditAction() && itemId) {
    return routes.formListEditActionReference(
      datasetId,
      formId,
      itemId,
      referenceDatasetId,
      field
    );
  }
  if (
    matchPath === routes.relative.formSubsetAddAction() &&
    itemId &&
    subsetId
  ) {
    return routes.formSubsetAddActionReference(
      datasetId,
      itemId,
      subsetId,
      formId,
      referenceDatasetId,
      field
    );
  }
  if (
    matchPath === routes.relative.formSubsetCopyAction() &&
    itemId &&
    subsetId &&
    subsetItemId
  ) {
    return routes.formSubsetCopyActionReference(
      datasetId,
      itemId,
      subsetId,
      formId,
      subsetItemId,
      referenceDatasetId,
      field
    );
  }
  if (
    matchPath === routes.relative.formSubsetEditAction() &&
    itemId &&
    subsetId &&
    subsetItemId
  ) {
    return routes.formSubsetEditActionReference(
      datasetId,
      itemId,
      subsetId,
      formId,
      subsetItemId,
      referenceDatasetId,
      field
    );
  }
};
